<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">
            <vx-tooltip class="position-icon" text="Chỉnh sửa" position="top">
                <feather-icon icon="EditIcon" class="action-success icon-btn"
                    svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="editHoliday" />
            </vx-tooltip>

            <vx-tooltip class="position-icon" text="Xóa" position="top" v-if="isPermissionDelete()">
                <feather-icon icon="TrashIcon" class="action-err icon-btn"
                    svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteHoliday" />
            </vx-tooltip>
        </div>
    </div>
</template>

<script>

import { isAPI, isRouter } from '../../../../../store/permission';
import { constAPI, constRouter } from '../../../../../store/constant';

export default {
    name: 'CellRendererActions',
    data() {
        return {
            userInfo: {}
        }
    },
    created() {
        let userInfo = JSON.parse(localStorage.getItem('userInfo') || {});
        this.userInfo = userInfo;
    },
    methods: {
        isPermissionDelete() {
            return isAPI(this, constAPI.holiday_delete)
        },
        editHoliday() {
            this.$router.push(`/user/manage-holiday-info?branch_id=${this.params.data.organizationBranchId}&id=${this.params.data.id}`)
                .catch(() => {
                })
        },

        confirmDeleteHoliday() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá ngày lễ này không ?`,
                accept: this.deleteHoliday,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },

        deleteHoliday() {
            this.$vs.loading();
            this.$crm.post('/holiday/delete/' + this.params.data.id).then(() => {
                this.$vs.loading.close();
                this.$store.commit('UPDATE_HOLIDAY', true);
                this.showDeleteSuccess();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        showDeleteSuccess() {
            this.$vs.notify({
                color: 'success',
                text: 'Xoá ngày lễ thành công!',
                iconPack: 'feather',
                icon: 'icon-check-circle',
            })
        }
    }
}
</script>
